/**
 * Turn an Error (often from customerFilesApi, whose messages embed the raw
 * "METHOD /path STATUS: body" string) into a short, human-readable message.
 * The UI should never show raw HTTP/JSON to end users.
 */
const STATUS_MESSAGES = {
  400: "That request wasn't valid. Please check the input and try again.",
  401: "Your session has expired. Please refresh the page and sign in again.",
  403: "You don't have permission to do that.",
  404: "That item could not be found.",
  409: "That conflicts with the current state. Refresh and try again.",
  413: "That file is too large.",
  429: "Too many requests — please wait a moment and try again.",
  500: "Something went wrong on our end. Please try again.",
  502: "The server is temporarily unavailable. Please try again.",
  503: "The server is temporarily unavailable. Please try again.",
};

export function friendlyError(err, fallback = "Something went wrong. Please try again.") {
  if (!err) return fallback;
  // customerFilesApi sets err.status on non-2xx responses.
  const status = typeof err.status === "number" ? err.status : null;
  if (status && STATUS_MESSAGES[status]) return STATUS_MESSAGES[status];
  const msg = typeof err === "string" ? err : err.message || "";
  // Strip the raw "METHOD /api/... NNN: {json}" shape our client throws.
  const m = msg.match(/\b(\d{3})\b/);
  if (m && STATUS_MESSAGES[m[1]]) return STATUS_MESSAGES[m[1]];
  // If the message still looks like a raw request/JSON dump, hide it.
  if (/^[A-Z]+\s+\/|^\{|\bhttps?:\/\//.test(msg) || msg.length > 140) return fallback;
  return msg || fallback;
}
